function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 22px;\n  height: 16px;\n  background: url(", ");\n  margin: 0;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 32px;\n  border-radius: 3px;\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  opacity: 1;\n  transition: opacity 0.3s;\n\n  &.infoPopup-enter,\n  &.infoPopup-exit.infoPopup-exit-active {\n    opacity: 0;\n  }\n\n  &.infoPopup-enter.infoPopup-enter-active,\n  &.infoPopup-exit {\n    opacity: 1;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1em;\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
import { MouseEnter } from "../mouseEnter/MouseEnter";
export var TooltipWrapper = styled(MouseEnter)(_templateObject());
export var TooltipPopup = styled.div(_templateObject2());
export var TooltipContent = styled.div(_templateObject3(), function (props) {
  return props.theme.variables.colors.white;
}, function (props) {
  return props.theme.variables.colors.blue;
}, function (props) {
  return props.theme.variables.typography.primaryFont;
});
export var TooltipArrow = styled.div(_templateObject4(), function (props) {
  return props.theme.variables.icons.svg.tooltipArrow;
}, function (props) {
  return props.arrowPlacement === 'top' ? "\n      bottom: -10px;    \n    " : "\n      top: -10px;\n      transform: rotateX(180deg);\n    ";
});